// modal.js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Typography,
    withStyles
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const styles = theme => ({
    dialogPaper: {
        borderRadius: 12,
        maxWidth: 1200,
        width: '90%',
        maxHeight: '85vh',
        margin: theme.spacing(2),
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
        border: '1px solid #E9ECEF',
        overflow: 'hidden',
        [theme.breakpoints.down('md')]: {
            maxWidth: 900,
        },
        [theme.breakpoints.down('sm')]: {
            maxWidth: '95%',
            width: '95%',
            margin: theme.spacing(1),
            borderRadius: 8,
            maxHeight: '90vh',
        },
        [theme.breakpoints.down('xs')]: {
            maxWidth: '100%',
            width: '100%',
            margin: 0,
            borderRadius: 0,
            maxHeight: '100vh',
            height: '100%',
        },
    },
    header: {
        padding: '24px 32px',
        borderBottom: '1px solid #E9ECEF',
        backgroundColor: '#F8F9FA',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: 0,
        [theme.breakpoints.down('sm')]: {
            padding: '16px 20px',
        },
    },
    modalTitle: {
        fontSize: '1.5rem',
        fontWeight: 700,
        color: '#1A1A1A',
        margin: 0,
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.25rem',
        },
    },
    closeButton: {
        padding: 0,
        color: '#6C757D',
        '&:hover': {
            color: '#495057',
            backgroundColor: 'transparent',
        },
    },
    content: {
        padding: '24px 32px',
        flex: 1,
        overflow: 'auto',
        [theme.breakpoints.down('sm')]: {
            padding: '16px 20px',
        },
    },
    footer: {
        padding: '24px 32px',
        borderTop: '1px solid #E9ECEF',
        backgroundColor: '#F8F9FA',
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 12,
        [theme.breakpoints.down('sm')]: {
            padding: '16px 20px',
            flexDirection: 'column-reverse',
            '& > *': {
                width: '100%',
                margin: '0 !important',
            },
        },
    },
});

class Modal extends Component {
    render() {
        const {
            classes,
            open,
            title,
            children,
            onClose,
            footer,
            ...otherProps
        } = this.props;

        return (
            <Dialog
                open={open}
                onClose={onClose}
                classes={{
                    paper: classes.dialogPaper,
                }}
                BackdropProps={{
                    style: {
                        backgroundColor: 'rgba(0, 0, 0, 0.3)',
                        backdropFilter: 'blur(4px)',
                    },
                }}
                {...otherProps}
                data-testid="modal-dialog"
            >
                <DialogTitle
                    disableTypography
                    className={classes.header}
                    data-testid="modal-header"
                >
                    <Typography variant="h5" className={classes.modalTitle}>
                        {title}
                    </Typography>
                    <IconButton
                        className={classes.closeButton}
                        onClick={onClose}
                        data-testid="button-close-modal"
                        size="small"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent className={classes.content} data-testid="modal-content">
                    {children}
                </DialogContent>

                {footer && (
                    <DialogActions className={classes.footer} data-testid="modal-footer">
                        {footer}
                    </DialogActions>
                )}
            </Dialog>
        );
    }
}

Modal.propTypes = {
    classes: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    onClose: PropTypes.func.isRequired,
    footer: PropTypes.node,
};

Modal.defaultProps = {
    footer: null,
};

export default withStyles(styles)(Modal);
